module.exports = __webpack_public_path__ + "img/thumb_image1.b42e4b10.jpg";